import React from "react";
import AuthGate from "../../../../components/AuthGate/AuthGate";
import AddBusiness from "./AddBusiness";

const AddBusinessGate = () => (
  <AuthGate>
    <AddBusiness />
  </AuthGate>
);

export default AddBusinessGate;
